<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    item-key="id"
    :items="batches"
    :search="search"
    no-data-text="Nothing to see here..."
    no-results-text="You filtered a little too hard there bud..."
  >
    <template v-slot:item.forgeID="{ item }">
      <BatchNavigation :instance="item"/>
    </template>
    <template v-slot:item.location.name="{ item }">
      <LocationTag :location="item.location"/>
    </template>
    <template v-slot:item.coatedquantity="{ item }">
      {{ item.coatedquantity }} {{ item.units }}
    </template>
    <template v-slot:item.action="{ item }" v-if="isDetail">
      <div class="d-inline-flex">
        <BatchForm
          :is-edit="false"
          :is-duplicate="true"
          :instance="item"
          :workid="workid"
        >
          <template #title>Copy {{ item.forgeID }}</template>
          <template #button="{ on }">
            <v-btn v-on="on" small icon>
              <v-icon small color="primary">mdi-content-copy</v-icon>
            </v-btn>
          </template>
        </BatchForm>
        <BatchSplitter :instance="item"/>
        <BatchStateChange :batch="item" :minimal="true" />
      </div>
    </template>
  </v-data-table>
</template>

<script>
import BatchForm from "./BatchForm";
import BatchSplitter from "./BatchSplitter";
import LocationTag from "../Locations/LocationTag";
import BatchNavigation from "./BatchNavigation";
import BatchStateChange from "./BatchStateChange";
export default {
  name: "BatchesTable",
  components: {
    BatchStateChange,
    LocationTag,
    BatchForm,
    BatchSplitter,
    BatchNavigation
  },
  props: {
    isDetail: {
      type: Boolean,
      required: true,
      default: false
    },
    workid: {
      type: [Number, String]
    },
    search: {
      type: String,
      required: true,
      default: ""
    },
    batches: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      headers: [
        { text: "ID", align: "left", sortable: true, value: "forgeID" },
        { text: "Title", sortable: true, value: "name" },
        {
          text: "Location",
          sortable: true,
          value: "location.name",
          align: "center"
        },
        {
          text: "Quantity",
          sortable: true,
          value: "coatedquantity",
          align: "center"
        },
        {
          text: "Cycles",
          sortable: true,
          value: "coatedcycles",
          align: "center"
        },
        { text: "Actions", sortable: false, align: "center", value: "action" }
      ]
    };
  }
};
</script>

